import React, { useState, useEffect } from "react";
import "../Teams/teams.scss";
import _ from "lodash";
import { teamsListService } from "../Teams/teams.service";
import { utilService } from "../../services";
import GlobalTeamAccordion from "./GlobalTeamAccordion";
import Loader from "../../components/Shared/Loader/Loader";
import InfiniteScroll from "react-infinite-scroll-component";
import NoResults from "../../components/Shared/NoResults/NoResultsComponent";

interface teammatesProps {
  fromSelectDropdown: boolean;
  searchInput: string;
}

const GlobalTeamSearch: React.FC<teammatesProps> = (props) => {
  const [otherUserList, setOtherUserList]: any = useState({});
  const [showLoader, setShowLoader]: [boolean, Function] = useState(false);
  const [pageNo, setPageNo]: [number, Function] = useState(1);

  const triggerTeammateList = () => {
    getTeammatesList();
  };

  const onScroll = () => {
    setPageNo(pageNo + 1);
    // getTeammatesList(pageNo + 1);
  };

  useEffect(() => {
    getTeammatesList();
  }, [props?.searchInput]);

  const getTeammatesList = async (page: number = 1) => {
    if (pageNo === 1) {
      setShowLoader(true);
    }

    let params: any = {};
    const respTeammatesList = await teamsListService.getfilteredTeammatesList(
      params,
      props?.searchInput,
      page
    );
    if (respTeammatesList.isSuccess && respTeammatesList.result) {
      // setOtherUserList(respTeammatesList?.result?.[0]?.data);

      if (page === 1) {
        setOtherUserList(respTeammatesList?.result?.[0]?.data);
      } else {
        let resultTeamData: any = otherUserList;
        let resultNewTeamData: any = respTeammatesList?.result?.[0]?.data;
        const combinedArray = [...resultTeamData, ...resultNewTeamData];
        const sortedData = [...combinedArray].sort((a, b) =>
          a.favorite === b.favorite ? 0 : a.favorite ? -1 : 1
        );
        setOtherUserList(sortedData);
      }
    } else {
      setOtherUserList([]);
      setPageNo(1);
    }

    setShowLoader(false);
  };
  //  else {
  //   // setPageNo(page + 1);
  //   // setOtherUserList([
  //   //     ...otherUserList,
  //   //     ...respTeammatesList.result?.[0]?.data,
  //   //   ]);
  // }

  //   if (respTeammatesList.isSuccess && respTeammatesList.result) {
  //     if (!_.isEmpty(respTeammatesList.result)) {

  //       if (pageNo === 1) {
  //         let resultDoctorListData = [...respTeammatesList.result?.[0]?.data];
  //         setOtherUserList(resultDoctorListData);

  //       }  else {
  //         setOtherUserList([
  //           ...otherUserList,
  //           ...respTeammatesList.result?.[0]?.data,
  //         ]);
  //       }
  //       setPageNo(pageNo + 1);
  //     }
  //   }
  //   setShowLoader(false);

  return (
    <div className="teams-container">
      {showLoader ? (
        <div className="loader-container">
          <Loader></Loader>
        </div>
      ) : (
        <div>
          <div className="teams-page-container">
            <div className="teams-header d-flex">
              <div className="d-flex align-items-center">
                {otherUserList && !_.isEmpty(otherUserList) ? (
                  <span className="title-name">{`Teammates`}</span>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="button-container"></div>
          </div>

          {otherUserList && !_.isEmpty(otherUserList) ? (
            <div
              className="scrollableDiv"
              onScroll={onScroll}
              style={{
                height: "80vh",
                overflow: "auto",
                width: window.innerWidth < 1024 ? "100%" : "",
              }}
            >
              <InfiniteScroll
                dataLength={otherUserList?.length}
                className="add-schedule-height"
                height={"550px"}
                hasMore={true}
                next={() => onScroll()}
                loader={<div></div>}
              >
                <div
                  className={`accordion-container ${
                    utilService.getScreenSize() !== "small"
                      ? "col-lg-12 home-accordian-section"
                      : ""
                  }
                   
                  `}
                >
                  <GlobalTeamAccordion
                    accordionList={otherUserList}
                    isFromTeams={true}
                    isFromUserCard={false}
                    isFromCaseHistoryDetails={""}
                    triggerTeammateList={triggerTeammateList}
                  />
                </div>
              </InfiniteScroll>
            </div>
          ) : (
            <div className="no-teams-results-label">
              <NoResults></NoResults>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default GlobalTeamSearch;
